import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

function Contact() {
 const [formData, setFormData] = useState({
   name: '',
   email: '',
   phone: '',
   message: '',
   website: '',
   gdprConsent: false,
 });
 const [status, setStatus] = useState({ success: null, message: '' });
 const [submitTime, setSubmitTime] = useState(null);
 const [isSubmitting, setIsSubmitting] = useState(false);

 useEffect(() => {
   setSubmitTime(Date.now());
 }, []);

 const handleChange = (e) => {
   const { name, value, type, checked } = e.target;
   setFormData((prev) => ({
     ...prev,
     [name]: type === 'checkbox' ? checked : value
   }));
 };

 const handleSubmit = async (e) => {
   e.preventDefault();

   if (formData.website) {
     setStatus({ success: false, message: 'Spam detected.' });
     return;
   }

   const timeElapsed = Date.now() - submitTime;
   if (timeElapsed < 3000) {
     setStatus({ success: false, message: 'Molimo vas popunite formu pažljivo.' });
     return;
   }

   if (!formData.name || !formData.email || !formData.phone || !formData.message) {
     setStatus({ success: false, message: 'Molimo vas popunite sva polja.' });
     return;
   }

   if (!formData.gdprConsent) {
     setStatus({ success: false, message: 'Molimo vas prihvatite politiku privatnosti.' });
     return;
   }

   if (isSubmitting) return;
   setIsSubmitting(true);

   try {
     const response = await fetch('/send.php', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(formData),
});

     if (response.ok) {
       setStatus({ success: true, message: 'Poruka je uspješno poslana! Hvala vam što ste nas kontaktirali.' });
       setFormData({ name: '', email: '', phone: '', message: '', website: '', gdprConsent: false });
     } else {
       throw new Error('Error sending message');
     }
   } catch (error) {
     setStatus({ success: false, message: 'Greška pri slanju poruke.' });
   } finally {
     setIsSubmitting(false);
   }
 };

 return (
   <section
     id='contact'
     className="page-section modern-contact py-5"
     style={{
       background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
       position: 'relative'
     }}
   >
     <div className="position-absolute top-0 start-0 w-100 h-100 overflow-hidden" style={{zIndex: 1}}>
       <div className="position-absolute rounded-circle" 
            style={{
              width: '180px',
              height: '180px',
              background: 'linear-gradient(45deg, rgba(66, 89, 168, 0.1), rgba(46, 141, 215, 0.1))',
              top: '20%',
              right: '8%',
              filter: 'blur(25px)'
            }}>
       </div>
       <div className="position-absolute rounded-circle" 
            style={{
              width: '150px',
              height: '150px',
              background: 'linear-gradient(45deg, rgba(46, 141, 215, 0.08), rgba(66, 89, 168, 0.08))',
              bottom: '15%',
              left: '10%',
              filter: 'blur(20px)'
            }}>
       </div>
     </div>

     <motion.div 
       className="container position-relative" 
       style={{zIndex: 2}}
       initial={{ opacity: 0, y: 50 }}
       whileInView={{ opacity: 1, y: 0 }}
       viewport={{ once: true, amount: 0.2 }}
       transition={{ duration: 1, ease: 'easeOut' }}
     >
       <div className="text-center mb-5">
         <h2 className="section-heading text-uppercase fw-bold mb-3 responsive-heading" 
             style={{
               color: '#4259A8',
               fontSize: '2.5rem',
               letterSpacing: '2px'
             }}>
           Kontaktirajte nas
         </h2>
         <div className="mx-auto mb-4" 
              style={{
                width: '80px',
                height: '4px',
                background: 'linear-gradient(90deg, #4259A8, #2E8DD7)',
                borderRadius: '2px'
              }}>
         </div>
         <h3 className="f-p1 mb-0" 
             style={{
               color: '#6c757d',
               fontSize: '1.2rem',
               fontWeight: '500'
             }}>
           Upiti / Rezervacije termina
         </h3>
       </div>

       <div className="row justify-content-center">
         <div className="col-lg-10">
           <div className="contact-form-wrapper p-5 rounded-3 shadow-sm"
                style={{
                  background: 'linear-gradient(145deg, rgba(255, 255, 255, 0.95), rgba(248, 249, 250, 0.95))',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  boxShadow: '0 10px 40px rgba(66, 89, 168, 0.1)'
                }}>
             
             <form id="contactForm" onSubmit={handleSubmit} noValidate>
               <div className="contact-main-wrapper row align-items-stretch mb-4">
                 <div className="contact-inner-wraper col-md-6">
                   <div className="form-group mb-4">
                     <input
                       id="name"
                       type="text"
                       name="name"
                       className="f-p1 form-control modern-input"
                       placeholder="Ime i prezime*"
                       value={formData.name}
                       onChange={handleChange}
                       required
                       autoComplete="name"
                       style={{
                         padding: '15px 20px',
                         fontSize: '1rem',
                         border: '2px solid rgba(66, 89, 168, 0.15)',
                         borderRadius: '10px',
                         background: 'rgba(255, 255, 255, 0.8)',
                         transition: 'all 0.3s ease',
                         color: '#495057'
                       }}
                     />
                   </div>

                   <div className="form-group mb-4">
                     <input
                       id="email"
                       type="email"
                       name="email"
                       className="f-p1 form-control modern-input"
                       placeholder="Email*"
                       value={formData.email}
                       onChange={handleChange}
                       required
                       autoComplete="email"
                       style={{
                         padding: '15px 20px',
                         fontSize: '1rem',
                         border: '2px solid rgba(66, 89, 168, 0.15)',
                         borderRadius: '10px',
                         background: 'rgba(255, 255, 255, 0.8)',
                         transition: 'all 0.3s ease',
                         color: '#495057'
                       }}
                     />
                   </div>

                   <div className="form-group mb-md-0">
                     <input
                       id="phone"
                       type="tel"
                       name="phone"
                       className="f-p1 form-control modern-input"
                       placeholder="Broj telefona*"
                       value={formData.phone}
                       onChange={handleChange}
                       required
                       autoComplete="tel"
                       style={{
                         padding: '15px 20px',
                         fontSize: '1rem',
                         border: '2px solid rgba(66, 89, 168, 0.15)',
                         borderRadius: '10px',
                         background: 'rgba(255, 255, 255, 0.8)',
                         transition: 'all 0.3s ease',
                         color: '#495057'
                       }}
                     />
                   </div>

                   <input 
                     type="text" 
                     name="website" 
                     tabIndex="-1"
                     autoComplete="off"
                     style={{ 
                       position: 'absolute',
                       left: '-5000px'
                     }} 
                     value={formData.website} 
                     onChange={handleChange} 
                   />
                 </div>

                 <div className="col-md-6">
                   <div className="form-group form-group-textarea mb-md-0">
                     <textarea
                       id="message"
                       name="message"
                       className="f-p1 form-control modern-input"
                       placeholder="Poruka*"
                       value={formData.message}
                       onChange={handleChange}
                       required
                       rows="8"
                       style={{
                         padding: '15px 20px',
                         fontSize: '1rem',
                         border: '2px solid rgba(66, 89, 168, 0.15)',
                         borderRadius: '10px',
                         background: 'rgba(255, 255, 255, 0.8)',
                         transition: 'all 0.3s ease',
                         color: '#495057',
                         resize: 'vertical',
                         minHeight: '180px'
                       }}
                     />
                   </div>
                 </div>

                 <div className="col-md-6">
 <div className="form-check d-flex align-items-start">
                     <input
                       type="checkbox"
                       id="gdprConsent"
                       name="gdprConsent"
                       className="form-check-input mt-1"
                       checked={formData.gdprConsent}
                       onChange={handleChange}
                       required
                       style={{
                         width: '1rem',
                         height: '1rem',
                         cursor: 'pointer',
                         border: '2px solid rgba(66, 89, 168, 0.3)',
                         borderRadius: '4px',
                         padding: '0.5rem'
                       }}
                     />
                     <label
                       htmlFor="gdprConsent"
                       className="form-check-label ms-3"
                       style={{
                         color: '#495057',
                         fontSize: '0.95rem',
                         lineHeight: '1.6',
                         cursor: 'pointer'
                       }}
                     >
                       Slažem se s obradom mojih osobnih podataka u svrhu odgovora na upit.
                       Pročitao/la sam{' '}
                       <Link
                         to="/politika-privatnosti"
                         style={{
                           color: '#4259A8',
                           textDecoration: 'underline',
                           fontWeight: '500'
                         }}
                       >
                         Politiku privatnosti
                       </Link>
                       .*
                     </label>
                   </div>
                 </div>
               </div>


               {status.success === true && (
                 <div className="col-md-6 custom-error alert alert-success text-center mb-4 rounded-3" 
                      style={{
                        backgroundColor: 'rgba(40, 167, 69, 0.15)',
                        border: '1px solid rgba(40, 167, 69, 0.3)',
                        color: '#155724'
                      }}>
                   <strong>{status.message}</strong>
                 </div>
               )}

               {status.success === false && (
                 <div className="col-md-6 custom-error alert alert-danger text-center mb-4 rounded-3"
                      style={{
                        backgroundColor: 'rgba(220, 53, 69, 0.15)',
                        border: '1px solid rgba(220, 53, 69, 0.3)',
                        color: '#721c24'
                      }}>
                   <strong>{status.message}</strong>
                 </div>
               )}

               <div className="text-center">
                 <button 
                   id="submitButton" 
                   className="btn btn-primary btn-xl text-uppercase modern-submit-btn px-5 py-3" 
                   type="submit"
                   disabled={isSubmitting}
                   style={{
                     background: 'linear-gradient(135deg, #4259A8 0%, #2E8DD7 100%)',
                     border: 'none',
                     borderRadius: '50px',
                     fontSize: '1.1rem',
                     fontWeight: '600',
                     letterSpacing: '1px',
                     boxShadow: '0 6px 20px rgba(66, 89, 168, 0.3)',
                     transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                     position: 'relative',
                     overflow: 'hidden',
                     opacity: isSubmitting ? 0.7 : 1,
                     cursor: isSubmitting ? 'not-allowed' : 'pointer'
                   }}
                 >
                   {isSubmitting ? 'Šaljem...' : 'Pošalji'}
                   <div className="shimmer-effect position-absolute top-0 start-0 w-100 h-100"
                        style={{
                          background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
                          transform: 'translateX(-100%)',
                          transition: 'transform 0.6s ease'
                        }}>
                   </div>
                 </button>
               </div>
             </form>
           </div>
         </div>
       </div>
     </motion.div>

     <style jsx>{`
       .modern-input:focus {
         outline: none !important;
         border-color: #4259A8 !important;
         box-shadow: 0 0 0 0.2rem rgba(66, 89, 168, 0.25) !important;
         background: rgba(255, 255, 255, 1) !important;
       }

       .modern-input::placeholder {
         color: #6c757d !important;
         opacity: 0.8 !important;
       }

       .modern-submit-btn:hover:not(:disabled) {
         transform: translateY(-2px) !important;
         box-shadow: 0 10px 30px rgba(66, 89, 168, 0.4) !important;
       }

       .modern-submit-btn:hover:not(:disabled) .shimmer-effect {
         transform: translateX(100%) !important;
       }

       .modern-submit-btn:active:not(:disabled) {
         transform: translateY(0) !important;
       }

       @media (max-width: 768px) {
         .responsive-heading {
           font-size: 1.6rem !important;
         }
       }
     `}</style>
   </section>
 );
}

export default Contact;